module.exports = __webpack_public_path__ + "static/media/UPL_logo.8772dc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/UPL_logo.png
// module id = 2487
// module chunks = 3